import moment from 'moment';
import React, {PropTypes} from 'react';

class TaskRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false
    };
    this.handleLabelClick = this.handleLabelClick.bind(this);
  }

  handleLabelClick() {
    const {selected} = this.state;
    this.setState({selected: !selected});
  }

  render() {
    const {
      task,
      firstDay,
      lastDay,
      onTaskTouchTap
    } = this.props;

    const days = lastDay.diff(firstDay, 'days') + 1;
    const one = 100 / days;
    let taskStartAt = moment(task.startAt);
    let taskEndAt = moment(task.endAt);
    if (taskStartAt < firstDay) {
      taskStartAt = firstDay
    }
    if (taskEndAt > lastDay) {
      taskEndAt = lastDay;
    }
    const styles = {
      backgroundColor: task.projectColor,
      width: `${(taskEndAt.diff(taskStartAt, 'days') + 1) * one}%`,
      marginLeft: `${(parseInt(taskStartAt.format('DD'), 10) - 1) * one}%`
    };

    const projectCap = task.projectLabel.substr(0,4);
    const labelClassName = this.state.selected ? 'project-label active' : 'project-label';
    return  <div className="project-row">
              <div className={labelClassName} onClick={this.handleLabelClick}>
                <span className="project-cap">{projectCap}</span>
                <div className="project-description">{task.projectLabel}</div>
              </div>
              <div className="bar" style={styles} onClick={() => onTaskTouchTap(task)}>{`${task.hours}h`}</div>
            </div>
  }
}

TaskRow.propTypes = {
  task: PropTypes.object.isRequired,
  firstDay: PropTypes.object.isRequired,
  lastDay: PropTypes.object.isRequired,
  onTaskTouchTap: PropTypes.func.isRequired
};

export default TaskRow;



/** WEBPACK FOOTER **
 ** ./src/components/TaskRow.js
 **/